export default __webpack_public_path__ + "static/media/explore-iv-banner-2.fe4aff25.png";